import { FC } from 'react'

import { TransactionDto } from '@model/TransactionDto'
import { TransactionStatus } from '@model/TransactionStatus'

import { Box } from '@shared/components/Box'
import { TransactionStatusIcon } from '@shared/components/StatusIcon/StatusIcon'

import { TransactionTypeIcon } from './TransactionTypeIcon'

import styles from './TransactionTypeWithStatusIcon.module.scss'

interface TransactionTypeWithStatusIconProps {
  transaction: TransactionDto
  status: TransactionStatus
}

export const TransactionTypeWithStatusIcon: FC<TransactionTypeWithStatusIconProps> = ({
  transaction,
  status,
}) => (
  <Box position='relative' flexItem='0 0 auto'>
    <TransactionTypeIcon transaction={transaction} variant='neutral' />
    <Box position='absolute' className={styles.statusBadge}>
      <TransactionStatusIcon status={status} size='x20' />
    </Box>
  </Box>
)
